import type { TruckSpec } from "./types";

export const TRUCK_SPECS: Array<TruckSpec> = [
  {
    id: "53-trailer-swing",
    label: "53' Trailer",
    lengthIn: 630,
    widthIn: 100,
    heightIn: 110,
    maxWeightLbs: 45_000,
    skidSpots: 26,
    group: "popular",
    category: "enclosed",
  },
  {
    id: "flatbed",
    label: "53' Flatbed",
    lengthIn: 636,
    widthIn: 102,
    heightIn: 110,
    maxWeightLbs: 48_000,
    skidSpots: null,
    group: "popular",
    category: "flatbed",
  },
  {
    id: "48-trailer",
    label: "48' Trailer",
    lengthIn: 570,
    widthIn: 102,
    heightIn: 108,
    maxWeightLbs: 44_000,
    skidSpots: 22,
    group: "popular",
    category: "enclosed",
  },
  {
    id: "40-container",
    label: "40' Container",
    lengthIn: 473,
    widthIn: 92,
    heightIn: 93,
    maxWeightLbs: 44_000,
    skidSpots: 20,
    group: "popular",
    category: "container",
  },
  {
    id: "large-straight-swing",
    label: "Large Straight Truck",
    lengthIn: 288,
    widthIn: 96,
    heightIn: 102,
    maxWeightLbs: 10_000,
    skidSpots: 12,
    group: "popular",
    category: "box-truck",
  },
  {
    id: "26-box-truck",
    label: "26' Box Truck",
    lengthIn: 312,
    widthIn: 100,
    heightIn: 96,
    maxWeightLbs: 10_000,
    skidSpots: 12,
    group: "popular",
    category: "box-truck",
  },
  {
    id: "cargo-van",
    label: "Cargo Van",
    lengthIn: 110,
    widthIn: 48,
    heightIn: 48,
    maxWeightLbs: 2_000,
    skidSpots: 2,
    group: "other",
    category: "van",
  },
  {
    id: "sprinter",
    label: "Sprinter",
    lengthIn: 130,
    widthIn: 48,
    heightIn: 71,
    maxWeightLbs: 3_300,
    skidSpots: 3,
    group: "other",
    category: "van",
  },
  {
    id: "small-straight",
    label: "Small Straight Truck",
    lengthIn: 144,
    widthIn: 84,
    heightIn: 84,
    maxWeightLbs: 5_000,
    skidSpots: 6,
    group: "other",
    category: "box-truck",
  },
  {
    id: "large-straight-roll",
    label: "Large Straight (Roll Door)",
    lengthIn: 288,
    widthIn: 96,
    heightIn: 98,
    maxWeightLbs: 10_000,
    skidSpots: 12,
    group: "other",
    category: "box-truck",
  },
  {
    id: "53-trailer-roll",
    label: "53' Trailer (Roll Door)",
    lengthIn: 630,
    widthIn: 100,
    heightIn: 98,
    maxWeightLbs: 45_000,
    skidSpots: 26,
    group: "other",
    category: "enclosed",
  },
  {
    id: "drop-deck-single",
    label: "Drop Deck (Single)",
    lengthIn: 444,
    widthIn: 102,
    heightIn: 120,
    maxWeightLbs: 48_000,
    skidSpots: null,
    group: "other",
    category: "drop-deck",
  },
  {
    id: "drop-deck-double",
    label: "Drop Deck (Double)",
    lengthIn: 348,
    widthIn: 102,
    heightIn: 138,
    maxWeightLbs: 48_000,
    skidSpots: null,
    group: "other",
    category: "drop-deck",
  },
];
